module.exports = __webpack_public_path__ + "img/di_16_RecPay.d8cba3b7.png";